angular
    .module('WizApp')
    .service('AuthenticationService', [
        '$http',
        '$filter',
        '$window',
        'PublicAccountService',
        function ($http, $filter, $window, PublicAccountService) {
            var route = $filter('route');

            return {
                resetPassword: function (email) {
                    return PublicAccountService.resetPassword(email);
                },

                login: function (user) {
                    const url = route('wizbii_onboardingui_login_check');
                    return $http.post(url, { _username: user.email, _password: user.password });
                },

                loginAccount: function (user) {
                    const accountDomain = window.sfParams.accountDomain ? window.sfParams.accountDomain : null;
                    const wizbiiDomain = window.sfParams.wizbiiDomain ? window.sfParams.wizbiiDomain : null;

                    if (accountDomain && wizbiiDomain) {

                        var redirect = localStorage.getItem('referer');
                        localStorage.removeItem('referer');

                        const url = accountDomain + '/api/login?redirect=' + (redirect || wizbiiDomain);
                        return $http.post(url, {
                            'app': 'website',
                            'username': user.email,
                            'password': user.password
                        }, {
                            transformRequest: data => JSON.stringify(data),
                            withCredentials: true,
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                    } else {
                        throw new RegisterServiceException(
                            'AuthenticationService Missing Variables',
                            'accountDomain or wizbiiDomain are undefined in window.sfParams'
                        );
                    }
                },

                register: function (user) {
                    const url = route('wizbii_onboardingui_register_profile');

                    return $http.post(url, {
                        'user_student_register_profile[firstName]': user.firstName,
                        'user_student_register_profile[lastName]':  user.lastName,
                        'user_student_register[username]':          user.email,
                        'user_student_register[password]':          user.password,
                        'user_student_register_profile[slug]':      user.slug || null,
                        'user_student_register_profile[type]':      user.type || null,
                        'user_student_register_profile[godfather]': user.godfather || 0
                    });
                },

                registerFacebookEmail: function (email) {
                    const url = route('wizbii_onboardingui_login_facebook_connect_email');

                    return $http.post(url, {
                        email
                    });
                },

                getRedirectRoute: (url, locationIntseadOfReferrer = false) => {
                    const defaultRedirect = angular.isString(url) ? url : '/';
                    const referrer = $window.document.referrer || '';
                    const wizbiiDomain = '^https?:\/\/([a-z]{1,3}\\.)?(qa\\d\\.)?(wzb|wizbii)\\.[a-z]{2,3}(:[0-9]{4})?';
                    const wizbiiDomainRegExp = new RegExp(wizbiiDomain, 'i');

                    const autoTarget = locationIntseadOfReferrer ? $window.document.location.href : referrer;

                    if (!wizbiiDomainRegExp.test(autoTarget)) {
                        return defaultRedirect;
                    }

                    // if the user comes from wizbii, we want to redirect
                    // him where he was before login in
                    // there are some exceptions to this rule
                    // some place that it wouldn't make sense to redirect him to
                    // those are listed below
                    const blacklist = [
                        new RegExp(`${wizbiiDomain}/?$`, 'i'),
                        new RegExp(`${wizbiiDomain}/login/?$`, 'i'),
                        new RegExp(`${wizbiiDomain}/register/`, 'i')
                    ];

                    return _.any(blacklist, it => it.test(autoTarget)) ? defaultRedirect : autoTarget;
                }
            };
        }
    ])
;
